module.exports = __webpack_public_path__ + "media/1_3_1-4.d5225d9d.mp3";